import React, { useEffect, useRef, useState } from "react";
import "../assets/css/Panel.css";
import Navbar from "../components/Navbar";
import {api} from "../utils/gashtaltAPI";
import ErrorPage from "../components/ErrorPage";
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Thead,
  Tr,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import { toPersianNumber } from "../utils/numberConversion";
import { toast } from "react-toastify";
import FilterTd from "../components/FilterTd";
import { RiFileExcel2Line } from "react-icons/ri";
import DownloadHandler from "../utils/downloadHandler";
import Loader from "../components/Loader";
import TableToolbar from "../components/TableToolbar";
import Pagination from "../components/Pagination";
import EmptyState from "../components/EmptyState";

function Users() {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);
  const {
    isOpen: nameOpen,
    onToggle: nameToggle,
    onClose: nameClose,
  } = useDisclosure();
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading,setLoading] = useState(false);
  const {
    isOpen: confirmOpen,
    onOpen: openConfirm,
    onClose: closeConfirm,
  } = useDisclosure();
  const [confirmData, setConfirmData] = useState(null);
  const cancelRef = useRef();

  const askConfirm = (message, action) => {
    setConfirmData({ message, action });
    openConfirm();
  };

  const handleConfirm = () => {
    if (confirmData) confirmData.action();
    closeConfirm();
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/api/users?page=${currentPage}`, {
          params: filters,
        });
        setUsers(response.data.data);
        setCurrentPage(response.data.current_page);
        setStartIndex(response.data.from);
        setLastPage(response.data.last_page);
        setTotal(response.data.total);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [currentPage, filters]);

  const changeRole = async (userId) => {
    setLoading(true)
    try {
      const response = await api.post("/api/users/updateRole", {
        user_id: userId,
      });
      setUsers((prevUsers) =>
        prevUsers.map((user, i) => ({
          ...user,
          role: user.id === userId ? response.data.role : user.role,
        }))
      );
      toast.success(response.data.message, {
        position: "bottom-right",
      });
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status !== 500) {
          toast.error(error.response.data.message, {
            position: "bottom-right",
          });
        }
        return;
      } else if (error.request) {
        toast.error("اتصال اینترنت خود را بررسی کنید!", {
          position: "bottom-right",
        });
        return;
      }
      toast.error("خطایی رخ داد!", {
        position: "bottom-right",
      });
    }finally {
      setLoading(false)
    }
  };
  const toggleStatus = async (userId) => {
    setLoading(true)
    try {
      const response = await api.post("/api/users/updateStatus", {
        user_id: userId,
      });
      setUsers((prevUsers) =>
        prevUsers.map((user, i) => ({
          ...user,
          active: user.id === userId ? response.data.active : user.active,
        }))
      );
      toast.success(response.data.message, {
        position: "bottom-right",
      });
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status !== 500) {
          toast.error(error.response.data.message, {
            position: "bottom-right",
          });
        }
        return;
      } else if (error.request) {
        toast.error("اتصال اینترنت خود را بررسی کنید!", {
          position: "bottom-right",
        });
        return;
      }
      toast.error("خطایی رخ داد!", {
        position: "bottom-right",
      });
    }finally {
      setLoading(false)
    }
  };

  if (loading) return <Loader />
  if (error) return <ErrorPage error={error} />;
  return (
    <div className="d-flex flex-column h-100">
      <Navbar />
      <div className="admin-page flex-fill">
        <TableToolbar title="کاربران" count={total}>
          <button
              className="btn btn-outline-green d-flex align-items-center gap-1"
              onClick={() => {
                DownloadHandler(
                  `${api.defaults.baseURL}/api/users/export`,
                  "users.xlsx",
                  { params: filters }
                );
              }}
          >
            <RiFileExcel2Line style={{fontSize:'1.1rem'}}/>
            خروجی اکسل
          </button>
        </TableToolbar>

        <div className="admin-table-card">
          <TableContainer>
            <Table variant="striped" colorScheme="teal">
              <Thead>
                <Tr>
                  <Td>ردیف</Td>
                  <Td>
                    <FilterTd
                      name={"نام و نام خانوادگی"}
                      defaultValue={filters.name}
                      onSubmit={(value) => {
                        setCurrentPage(1);
                        setFilters((prevFilters) => ({
                          ...prevFilters,
                          name: value,
                        }));
                      }}
                      onCancel={() => {
                        setCurrentPage(1);
                        setFilters((prevFilters) => {
                          const { name, ...rest } = prevFilters;
                          return rest;
                        });
                      }}
                    />
                  </Td>
                  <Td>
                    <FilterTd
                      name={"شماره همراه"}
                      defaultValue={filters.phone_number}
                      onSubmit={(value) => {
                        setCurrentPage(1);
                        setFilters((prevFilters) => ({
                          ...prevFilters,
                          phone_number: value,
                        }));
                      }}
                      onCancel={() => {
                        setCurrentPage(1);
                        setFilters((prevFilters) => {
                          const { phone_number, ...rest } = prevFilters;
                          return rest;
                        });
                      }}
                    />
                  </Td>
                  <Td>نقش</Td>
                  <Td>وضعیت</Td>
                </Tr>
              </Thead>
              <Tbody>
                {users.map((user, index) => (
                  <Tr key={user.id}>
                    <Td>{toPersianNumber(startIndex+index)}</Td>
                    <Td>{user.name}</Td>
                    <Td style={{direction:'ltr',textAlign:'end'}}>{toPersianNumber(user.phone_number)}</Td>
                    <Td>
                      <button
                        className={`status-pill ${user.role === 0 ? "is-neutral" : "is-on"}`}
                        title="برای تغییر نقش کلیک کنید"
                        onClick={() => {
                          askConfirm(
                            `آیا از تغییر نقش «${user.name}» به ${
                              user.role === 0 ? "مدیر" : "کاربر"
                            } مطمئن هستید؟`,
                            () => changeRole(user.id)
                          );
                        }}
                      >
                        <span className="status-dot"></span>
                        {user.role === 0 ? "کاربر" : "مدیر"}
                      </button>
                    </Td>
                    <Td>
                      <button
                        className={`status-pill ${user.active ? "is-on" : "is-off"}`}
                        title="برای تغییر وضعیت کلیک کنید"
                        onClick={() => {
                          askConfirm(
                            `آیا از تغییر وضعیت «${user.name}» به ${
                              user.active ? "غیرفعال" : "فعال"
                            } مطمئن هستید؟`,
                            () => toggleStatus(user.id)
                          );
                        }}
                      >
                        <span className="status-dot"></span>
                        {user.active ? "فعال" : "غیرفعال"}
                      </button>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
          {users.length === 0 && <EmptyState text="کاربری یافت نشد." />}
        </div>

        <Pagination currentPage={currentPage} lastPage={lastPage} onChange={setCurrentPage} />
      </div>

      <AlertDialog
        isOpen={confirmOpen}
        leastDestructiveRef={cancelRef}
        onClose={closeConfirm}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent className="confirm-dialog">
            <AlertDialogHeader className="confirm-dialog-header">
              تایید عملیات
            </AlertDialogHeader>
            <AlertDialogBody className="confirm-dialog-body">
              {confirmData?.message}
            </AlertDialogBody>
            <AlertDialogFooter className="confirm-dialog-footer">
              <button
                ref={cancelRef}
                className="btn btn-outline-green"
                onClick={closeConfirm}
              >
                انصراف
              </button>
              <button className="btn btn-green" onClick={handleConfirm}>
                تایید
              </button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </div>
  );
}

export default Users;
